
const SWIPER_OPTIONS = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  observer: true,
  observeParents: true,
  mousewheel: {
    forceToAxis: true,
    releaseOnEdges: true,
  },
};

class CartRecommendedProductsSwiper extends HTMLElement {
  #swiper;

  #generation = 0;

  #justConnected = false;

  connectedCallback() {
    if (this.#swiper) return;
    this.#initSwiper();
    this.#justConnected = true;
    queueMicrotask(() => {
      this.#justConnected = false;
    });
  }


  disconnectedCallback() {
    this.#generation++;
    this.#swiper?.destroy(true, true);
    this.#swiper = undefined;
  }

  async #initSwiper() {
    const generation = ++this.#generation;
    const { default: Swiper } = await import('@theme/swiper');
    if (!this.isConnected || generation !== this.#generation || this.#swiper) return;
    this.#swiper = new Swiper(this, SWIPER_OPTIONS);
  }

  reinit() {
    if (this.#justConnected) return;
    this.#swiper?.destroy(true, true);
    this.#swiper = undefined;
    this.#initSwiper();
  }
}

if (!customElements.get('cart-recommended-products-swiper')) {
  customElements.define('cart-recommended-products-swiper', CartRecommendedProductsSwiper);
}

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target instanceof Element ? event.target : document;
  root.querySelectorAll('cart-recommended-products-swiper').forEach((element) => {
    if (element instanceof CartRecommendedProductsSwiper) element.reinit();
  });
});


